import Image from 'next/image';

import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import ServiceIcon from '../ServiceIcon';


const ServicesPanel = ({ services, defaultExpanded = true }) => {
  const imgPath = (category) => {
    const name = category ? category.replace(/ |,|-|'/g, '').toLowerCase() : 'serviceandmaintenance';
    return `/icons/service-icons-blue/${name}.png`
  }
  
  return (
    <Accordion
      sx={{
        my: 2,
        '&::before': {
          display: 'none',
        },
      }}
      elevation={0}
      square
      defaultExpanded={defaultExpanded}
      TransitionProps={{ unmountOnExit: !defaultExpanded }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h5">Services</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box width="100%">
          {services.map(cat_services => (
            <Accordion
              elevation={0}
              key={cat_services.category}
              TransitionProps={{ unmountOnExit: true }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box display="flex" mr={1} minWidth={24} maxHeight={24}>
                  <Image
                    src={imgPath(cat_services.category)}
                    width={24}
                    height={24}
                    alt={cat_services.category}
                  />
                </Box>
                <Typography variant="body1">{cat_services.category}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box
                  component="ul"
                  sx={{
                    m: 0,
                    fontSize: 'body2.fontSize'
                  }}
                >
                  {cat_services.services.map(service => (
                    <li key={service}>{service}</li>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default ServicesPanel;
